import { Component, Directive, OnInit, ElementRef, Renderer } from '@angular/core';
import { CasillaActualService } from 'src/app/services/casilla-actual.service';
import { ICasilla, INotificacionBandeja, INotificacionDetalle, IContadorCasilla, IAgrupacionNotificacion } from 'src/app/modelos/casilla.interface';
import { IAdministrarNotificacionFiltroBuscarRequest } from 'src/app/modelos/filtro-api.interface';
import { IDataGridPageRequest } from 'src/app/modelos/data-grid.interface';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { THIS_EXPR, ThrowStmt } from '@angular/compiler/src/output/output_ast';
import { Route } from '@angular/compiler/src/core';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/shared/services/toast.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { config } from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as CryptoJS from 'crypto-js';
import { PaisModel } from '../home/store/registro-usuario.store.model';
import { TipoDocumentoPaisModel, PersonaNaturalRequest, DatosEmail } from '../home/store/registro-usuario.store.model';
import { environment } from 'src/environments/environment';


//import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
 

const ERROR_GENERAL = "Ocurrió un error durante la transacción. Comuníquese con el Administrador del Sistema.";

declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
  
})

export class HomeComponent implements OnInit 
{ 
  closeResult: string;

  fileUrl;

  datosEmail: DatosEmail;
  personaNaturalRequest: PersonaNaturalRequest;

  isShowModalDatos: boolean = false;
  isShowModalTC: boolean = true;
  isShowModalCPDP: boolean = true;

  isShowEX: boolean = false;
  isShowPJ: boolean = false;
  isShowPN: boolean = false;

  isShowFin: boolean = true;
  isShowProceso: boolean = false;

  //hablitar checks
  isDisabledTC: boolean = true;
  isDisabledCPDP: boolean = true;

  //valores de los check
  chkCPDP: boolean = false;
  chkTC: boolean = false;

  //visor de contraseñas
  isTypeP1bol = false; 
  isTypeP2bol = false; 

  //cambie el type de la contraseña
  isTypeP1 = null;
  isTypeP2 = null;

  //bloquear correo y telefono si los trae
  isReadonlyC = true;
  isReadonlyT = true;

  //bloquear correo y telefono si tiene datos en los registros 1
  isReadonlyC2 = true;
  isReadonlyT2 = true;

  isReadonlyDni = true;

  caracteres: string;
  urlPortal: string;

  lblRepresentante: string = "";
  
  stepTipoRegistro: string = "";
  stepRepresentante: string = "";
  stepRegistroDatos: string = "";
  stepClave: string = "";
  stepConfirmar: string = "";

  stepTipoRegistroL: string = "";
  stepRepresentanteL: string = "";
  stepRegistroDatosL: string = "";
  stepClaveL: string = "";
  stepConfirmarL: string = "";

  selectedTipoRegistro: string="";

  registroUsuarioDatos:{
    tipoRegistro: number,
    pais: number,
    tipoDocumento: number,
    uNroDocumento: string,
    dRazonSocial: string,
    dCorreo1: string,
    dCorreo2: string,
    dTelefono1: string,
    dTelefono2: string,
    clave: string,
    tipoDocRepresentante: number,
    nroDocRepresentante: string,
    nombreRepresentante: string,
    apPatRepresentante: string,
    apMatRepresentante: string,
    pkPJ: number
  } = {
    tipoRegistro: 1,
    pais: 1,
    tipoDocumento: 13,
    uNroDocumento: "",
    dRazonSocial: "",
    dCorreo1: "",
    dCorreo2: "",
    dTelefono1: "",
    dTelefono2: "",
    clave: null,
    tipoDocRepresentante: 1,
    nroDocRepresentante: "",
    nombreRepresentante: "",
    apPatRepresentante: "",
    apMatRepresentante: "",
    pkPJ: 0
  }

datosRegistro: {
  nroDocumento: string,
  razonSocial: string,
  correo1: string,
  correo2: string,
  telefono1: string,
  telefono2: string,
  clave: string,
  claveSeg: string,
  resumenCorreo: string,
  resumenTelefono: string,

  pPais: number,
  tipDoc: number,
  TipoDocumento: string,
  nroDocRepresentante: string,
  nombresRepresentante: string,
  apPatRepresentante: string,
  apMatRepresentante: string,
  
  pkPJ: number
} = {
  nroDocumento: "",
  razonSocial: "",
  correo1: "",
  correo2: "",
  telefono1: "",
  telefono2: "",
  clave: "",
  claveSeg: "",
  resumenCorreo: "",
  resumenTelefono: "",

  pPais: 1,
  tipDoc: 1,
  TipoDocumento: "",
  nroDocRepresentante: "",
  nombresRepresentante: "",
  apPatRepresentante: "",
  apMatRepresentante: "",

  pkPJ: 0
}

paises: PaisModel[];  
selectedPais: number;

tipoDocumentoPais: TipoDocumentoPaisModel[];
selectedTipDocPais: number;

tipDocPaso2: TipoDocumentoPaisModel[];
selectTipDocPaso2: number;
tipDocPase: string;

/*comboLists = {
  tipDocPaso2: TipoDocumentoPaisModel[]
};*/

  constructor(
    //private modalService: NgbModal,

    private _formBuilder: FormBuilder,

    public casillaActualService: CasillaActualService,
    private usuariosService: UsuariosService,
    private router: Router,
    private toast: ToastService,
    private alertService: AlertService
  ) {   
    //this.casillaActual = casillaActualService.getCasillaActual()
    /*var events = 'cut copy paste';
    events.split(' ').forEach(e => 
    renderer.listen(el.nativeElement, e, (event) => {
      event.preventDefault();
      })
    );*/
	 
  }

  ngOnInit() {
    
    // this.buscarNotificacionesInicial();

    this.isShowModalDatos = false;
    this.isShowModalTC = true;
    this.isShowModalCPDP = true;

    this.isShowEX = false;
    this.isShowPJ = false;
    this.isShowPN = false;

    this.isShowFin = true;
    this.isShowProceso = false;

    this.isDisabledTC = true;
    this.isDisabledCPDP = true;
    
    this.chkCPDP = false;
    this.chkTC = false;

    this.isTypeP1 = "password"
    this.isTypeP2 = "password"

    this.stepTipoRegistro = "active"
    this.stepTipoRegistroL = ""
    this.selectedTipoRegistro = ""

    if(this.datosRegistro.correo1 == "")
    {
      this.isReadonlyC = !this.isReadonlyC;
    }

    if(this.datosRegistro.telefono1 == "")
    {
      this.isReadonlyT = !this.isReadonlyT;
    }
    this.selectedPais = 0;
    this.selectedTipDocPais = 0;

    this.caracteres = "!#$%&'()*+,-./:;<=>?@[\]^_`{|}~.";
    this.urlPortal = environment.loingUrlPortal;

    this.tipDocPase = "";

    //Tipos de Documentos para en paso 2
    this.listarTipDocPaso2(1);
    

    this.listarPais();
    this.listarTipoDocumentoPais(0);
    //this.setFiltroBandejaInicial();
    //this.setFiltroPaginadorInicial();   

    //this.buscarNotificacionesInicial();
    //this.listarAgrupacionesNotificaciones();
  }

valuechange(newValue){

  /*if(newValue == "")
  {
    this.datosRegistro.razonSocial = "";
  }*/
  this.datosRegistro.razonSocial = "";
  this.datosRegistro.telefono1 = "";
  this.datosRegistro.telefono2 = "";
  this.datosRegistro.correo1 = "";
  this.datosRegistro.correo2 = "";

}

valuechangeDni(newValue){

  /*if(newValue == "")
  {
    this.datosRegistro.razonSocial = "";
  }*/
  this.datosRegistro.apMatRepresentante = "";
  this.datosRegistro.apPatRepresentante = "";
  this.datosRegistro.nombresRepresentante = "";

}

handleSelectTip(event){
  //this.tipDocPase = this.tipDocPaso2[this.selectTipDocPaso2].uDescripcion;
  if(this.selectTipDocPaso2 == 2)
  {
    this.isReadonlyDni = true
  }
  else{
    this.isReadonlyDni = false
  }
  this.tipDocPaso2.forEach(element => {
    if(element.eIdDetalle == this.selectTipDocPaso2)
    {
      this.tipDocPase = element.uDescripcion;
    }
  });
  //console.log(this.tipDocPaso2[this.selectTipDocPaso2].uDescripcion)
  
  /*this.tipDocPaso2.forEach(element => {
    if(parseInt(event.target.value) == element.eIdDetalle){
      console.log(element.uDescripcion)
    }
  });*/
}

tieneDatosE(newValue){

  let dato = newValue;
  if(dato.length == 0)
  {
    this.isReadonlyC2 = true;
    this.datosRegistro.correo2 = "";
  }
  else
  {
    this.isReadonlyC2 = false;
  }
  

}

tieneDatosT(newValue){

  let dato = newValue;
  if(dato.length == 0)
  {
    this.isReadonlyT2 = true;
    this.datosRegistro.telefono2 = "";
  }
  else
  {
    this.isReadonlyT2 = false;
  }
  

}

listarPais = () => {
    this.usuariosService.listarPais(1).subscribe(data => this.paises = data.result
      //,error => console.log(error)
      );
}

handleChangePais(event) {
  this.listarTipoDocumentoPais(this.selectedPais);
}

listarTipoDocumentoPais = (idPais: number) => {
  this.selectedTipDocPais = 0;
  //jclr
  this.usuariosService.listarTipoDocumentoPais(idPais, 4).subscribe(data => this.tipoDocumentoPais = data.result
    //,error => console.log(error)
    );
}

listarTipDocPaso2 = (tipo: number) => {
  this.selectTipDocPaso2 = 0;
  //jclr
  this.usuariosService.listarTipoDocumentoPais(1,tipo).subscribe(data => this.tipDocPaso2 = data.result
    //,error => console.log(error)
    );
}

  encriptarClave = (dato: string): string => {
    return CryptoJS.MD5(dato).toString();
  };

  enviarEmailDatosUsuario = (login, prueba, cuerpo, flag) => {
    this.usuariosService.enviarEmailDatosUsuario(login, prueba,cuerpo, flag).subscribe(
          (data) => {
            //console.log(data) 
          },
        (error) => {
            //console.log(error)
        }
    );
  };

  demorenat(ruc){
    this.usuariosService.servicioRenat(ruc).subscribe(
      (data) => {
        console.log(data) 
      },
    (error) => {
        console.log(error)
    }
);
  }
  registroUsuario = () =>
  {
    if (!this.isShowPJ){
      this.registroUsuarioDatos.tipoRegistro = 1;
      this.registroUsuarioDatos.pais = 104;
      this.registroUsuarioDatos.tipoDocumento = 120; //RUC
      this.registroUsuarioDatos.dRazonSocial = this.datosRegistro.razonSocial;
      this.registroUsuarioDatos.pkPJ = this.datosRegistro.pkPJ;
    }
    else if(!this.isShowPN){
      this.registroUsuarioDatos.tipoRegistro = 2;
      this.registroUsuarioDatos.pais = 104;
      this.registroUsuarioDatos.tipoDocumento = this.selectTipDocPaso2; //DNI
      this.registroUsuarioDatos.dRazonSocial = "";
      this.registroUsuarioDatos.pkPJ = 0;
    }
    else if(!this.isShowEX){
      this.registroUsuarioDatos.tipoRegistro = 3;
      this.registroUsuarioDatos.pais = this.selectedPais;
      this.registroUsuarioDatos.tipoDocumento = this.selectedTipDocPais;
      this.registroUsuarioDatos.dRazonSocial = this.datosRegistro.razonSocial;
      this.registroUsuarioDatos.pkPJ = 0;
    }
    
    this.registroUsuarioDatos.uNroDocumento = this.datosRegistro.nroDocumento;
    
    this.registroUsuarioDatos.dCorreo1 = this.datosRegistro.correo1;
    if(this.datosRegistro.correo2 == "")
    {
      this.registroUsuarioDatos.dCorreo2 = null;
    }
    else
    {
      this.registroUsuarioDatos.dCorreo2 = this.datosRegistro.correo2;
    }      
    this.registroUsuarioDatos.dTelefono1 = this.datosRegistro.telefono1;
    if(this.datosRegistro.correo2 == "")
    {
      this.registroUsuarioDatos.dTelefono2 = null;
    }
    else
    {
      this.registroUsuarioDatos.dTelefono2 = this.datosRegistro.telefono2;
    }
    this.registroUsuarioDatos.clave = this.encriptarClave(this.datosRegistro.clave);

    this.registroUsuarioDatos.tipoDocRepresentante = this.selectTipDocPaso2;
    this.registroUsuarioDatos.nroDocRepresentante = this.datosRegistro.nroDocRepresentante;
    this.registroUsuarioDatos.nombreRepresentante = this.datosRegistro.nombresRepresentante;
    this.registroUsuarioDatos.apPatRepresentante = this.datosRegistro.apPatRepresentante;
    this.registroUsuarioDatos.apMatRepresentante = this.datosRegistro.apMatRepresentante;
    
    this.usuariosService.registroUsuarioServicio(this.registroUsuarioDatos).subscribe(
        (data) => {
          
          if(data.success)
          {
            var tipMensaje = "";
            if(!this.isShowPJ)
              tipMensaje = "RUC";
            else if(!this.isShowPN)
            {
              tipMensaje = "DNI";
              this.datosRegistro.razonSocial = this.datosRegistro.apPatRepresentante.toUpperCase() + " " + this.datosRegistro.apMatRepresentante.toUpperCase() + " " + this.datosRegistro.nombresRepresentante.toUpperCase();
            }
            else if(!this.isShowEX)
              tipMensaje = "Usuario";

            //var mensaje = "<div align=center style='border: 1px solid #000000; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:black;'><span style='color:white;' >ACCESO AL PORTAL DEL ADMINISTRADO DE PROVÍAS NACIONAL</span></div><div> <span>Estimados : </span><b>"+this.datosRegistro.razonSocial+"</b></br><span>Su registro fue generado de forma satisfactoria al <b>PORTAL DE SERVICIOS DE PROVÍAS NACIONAL</b> ahora podrá realizar sus trámites en linea</span></div><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'><span style='color:black;' ><b>SUS CREDENCIALES</b></span><div style='overflow:hidden;'><div style=' float: left;width: 50%;'> <div align=center style='border: 1px solid #82E0AA; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#ABEBC6;'> <span style='color:black;' ><b>"+ tipMensaje +": </b></span></br><span style='color:black;' ><b>"+this.datosRegistro.nroDocumento+"</b></span></div></div><div style='float:left;width: 50%;'> <div align=center style=' border: 1px solid #82E0AA; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#ABEBC6;'> <span style='color:black;' ><b>Contraseña: </b></span></br><span style='color:black;' ><b>"+this.datosRegistro.clave+"</b></span></div></div><span style='color:black;' ><b>ACCEDA AL PORTAL</b></span></br><span style='color:black;' ><a href='http://www.pvn.gob.pe'>www.pvn.gob.pe</a></span></div></div></br><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'> <span style='color:red;' ><b>IMPORTANTE</b></span></br> <span style='color:black;' ><b>El usuario y contraseña es personal e intransferible y el uso del mismo será bajo su responsabilidad</b></span> </div> </br><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'> <span style='color:red;' ><b>CONTACTENOS</b></span><ul style='list-style: none '> <li>Central Telefónica 615-7800</li></ul></div>";
            //var mensaje = "<div align=center style='border: 1px solid #000000; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:black;'><span style='color:white;' >ACCESO AL PORTAL DE SERVICIOS DE PROVÍAS NACIONAL</span></div><div><span>Estimados : </span><b>"+this.datosRegistro.razonSocial+"</b></div><div><span>Su registro fue generado de forma satisfactoria al <b>PORTAL DE SERVICIOS DE PROVÍAS NACIONAL</b> ahora podrá realizar sus trámites en línea.</span></div><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'><span style='color:black;' ><b>SUS CREDENCIALES</b></span><div style='overflow:hidden;'><div style=' float: left;width: 50%;'><div align=center style='border: 1px solid #82E0AA; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#ABEBC6;'><div><span style='color:black;' ><b>"+ tipMensaje +"</b></span></div><div><span style='color:black;' ><b>"+this.datosRegistro.nroDocumento+"</b></span></div></div></div><div style='float:left;width: 50%;'><div align=center style=' border: 1px solid #82E0AA; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#ABEBC6;'><div><span style='color:black;' ><b>Contraseña</b></span></div><div><span style='color:black;' ><b>"+this.datosRegistro.clave+"</b></span></div></div></div><div><span style='color:black;' ><b>ACCEDA AL PORTAL EN</b></span></div><div><span style='color:black;' ><a href='"+environment.loingUrlPortal+"'>este enlace</a></span></div></div></div></br><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'><div><span style='color:red;' ><b>IMPORTANTE</b></span></br></div><div><span style='color:black;' ><b>El usuario y contraseña es personal e intransferible y el uso del mismo será bajo su responsabilidad</b></span></div></div></br><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'><div><span style='color:red;' ><b>CONTACTENOS</b></span></div><div><span align=center >Central Telefónica 615-7800</span></div></div>";

            //this.enviarEmailDatosUsuario(this.datosRegistro.correo1, "Registro de Usuario PROVÍAS",mensaje,true);

            this.emailRegistro(tipMensaje,this.datosRegistro.nroDocumento,this.datosRegistro.razonSocial,"",this.datosRegistro.correo1,"Registro de Usuario PROVÍAS",this.datosRegistro.clave)

            if(this.datosRegistro.correo2 != ""){
              //this.enviarEmailDatosUsuario(this.datosRegistro.correo2, "Registro de Usuario PROVÍAS",mensaje,true);
              this.emailRegistro(tipMensaje,this.datosRegistro.nroDocumento,this.datosRegistro.razonSocial,"",this.datosRegistro.correo2,"Registro de Usuario PROVÍAS",this.datosRegistro.clave)
            }

          }
        },
        (error) => {
          //console.log(error)
        }
      )
  }

  textoNumerico = (clave) => {
    let hasNumber = /\d/.test(clave);
    //let hasUpper = /[A-Z]/.test(clave);
    //let hasLower = /[a-z]/.test(clave);
    //let hasSymbol = /[!#$%&'()*+,-./:;<=>?@\^_`{|}~.]/.test(clave);//--!#$%&'()*+,-./:;<=>?@[\]^_`{|}~.
    //let hasSymbol = /^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{8,20}$/.test(clave);
    // console.log('Num, Upp, Low', hasNumber, hasUpper, hasLower);
    const valid = hasNumber; // && hasUpper && hasLower && hasSymbol;
    if (!valid) {
        // return what´s not valid
        return { strong: true };
    }
    return false;
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  numberdown(event){
    const charCode = (event.which) ? event.which : event.keyCode;
    if(charCode == 9 || charCode == 13){
      this.handleValidarPJ();
    }
  }

  numberdownDni(event){
    const charCode = (event.which) ? event.which : event.keyCode;
    if(charCode == 9 || charCode == 13){
      this.handleValidarPN();
    }
  }

  numberOnlyPaste(event): boolean {
    let texto = Array.from(event)
    let new_texto = ""
    texto.forEach(element => {
      if(element == "1" || element == "2" || element == "3" || element == "4"
      || element == "5" || element == "6" || element == "7" || element == "8"
      || element == "9" || element == "0"){
        new_texto = new_texto + element;
      }
    });
    this.datosRegistro.nroDocRepresentante = new_texto;
    return true;
  }

  leterOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) || 
        (charCode >= 97 && charCode <= 122) || charCode == 32 || charCode == 39 || 
        (charCode >= 128 && charCode <= 154) ||
        (charCode >= 160 && charCode <= 165) ||
        (charCode >= 181 && charCode <= 183) ||
        (charCode >= 198 && charCode <= 199) ||
        (charCode >= 209 && charCode <= 216) ||
        (charCode >= 224 && charCode <= 229)
        ) {
      return true;
    }
    return false;
  }

  esEmailValido(email: string):boolean {
    let mailValido = false;
      'use strict';

      var EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      if (email.match(EMAIL_REGEX)){
        mailValido = true;
      }
    return mailValido;
  }

  setradio(e: string): void {
    switch(e) {
      case "PJ":  this.isShowPJ = false;
                  this.isShowPN = true;
                  this.isShowEX = true;
                  this.lblRepresentante = "REPRESENTANTE";
                  break;
      case "PN":  this.isShowPJ = true;
                  this.isShowPN = false;
                  this.isShowEX = true;
                  this.lblRepresentante = "PERSONA";
                  break;
      case "EX":  this.isShowPJ = true;
                  this.isShowPN = true;
                  this.isShowEX = false;
                  this.lblRepresentante = "REPRESENTANTE";
                  break;
    }
    this.selectedTipoRegistro = e;
  }

  handleCerrar = () => {
    this.router.navigate(['/login/']);
    //location.href = environment.loingUrlPortal;
    this.urlPortal 
  }

  handleCancelar = () => {
    //this.router.navigate(['/login/']);
    //location.href = environment.loingUrlPortal;
    location.href = this.urlPortal 
  }

  handleVisorP = (type) => {
    switch (type) {
      case 1: this.isTypeP1bol = !this.isTypeP1bol;
              if(this.isTypeP1bol)
              {
                this.isTypeP1 = "text";
              }
              else
              {
                this.isTypeP1 = "password";
              }
              break;
        case 2: this.isTypeP2bol = !this.isTypeP2bol;
              if(this.isTypeP2bol)
              {
                this.isTypeP2 = "text";
              }
              else
              {
                this.isTypeP2 = "password";
              }
              break;
    }
  }

  handleValidarPJ = () => {
    //let documentoIdentidad = this.form.get('documentoIdentidad').value;
    
    if(this.datosRegistro.nroDocumento == "")
    {
      this.toast.error("Debe ingresar el RUC");
    }
    /*else if(this.rucPJ.value.length < 11)
    {
      this.toast.error("El RUC debe tener 11 caracteres");
    }*/
    else{

      
        this.usuariosService.servicioSunat(this.datosRegistro.nroDocumento).subscribe(
          (response) => {
            if (response.success){
              if(response.data != null){
                this.datosRegistro.razonSocial = response.data.uNombreCompleto.trim();
                this.datosRegistro.pkPJ = response.data.pkeIdPersona;
              }
              else{
                this.toast.error("RUC no se encuentra registrado");
              }
            }
            else{
              this.toast.error("RUC no se encuentra registrado");
            }  
          },
        (error) => {
            console.log(error)
        })   
    }
  }

  handleValidarPN = () => {
    //let documentoIdentidad = this.form.get('documentoIdentidad').value;
    if(this.selectTipDocPaso2 != 2)
    {
      return;
    }
    if(this.datosRegistro.nroDocRepresentante == "")
    {
      this.toast.error("Debe ingresar el Nro Documento");
    }
    else{
      this.personaNaturalRequest = {
        eIdTipoDocumento: this.selectTipDocPaso2,
        uNroDocumento : this.datosRegistro.nroDocRepresentante
      }
      this.usuariosService.servicioDniPide(this.personaNaturalRequest).subscribe(
        (response) => {
          if (response.success){
            if(response.data != null){
              this.datosRegistro.nombresRepresentante = response.data.uNombres.trim();
              this.datosRegistro.apPatRepresentante = response.data.uApellidoPaterno.trim();
              this.datosRegistro.apMatRepresentante = response.data.uApellidoMaterno.trim();
            }
            else{
              this.toast.error("Nro Documento no se encuentra registrado");
            }
          }
          else{
            this.toast.error("Nro Documento no se encuentra registrado");
          }  
        },
      (error) => {
          console.log(error)
      })
          
    }
  }

  handleChangeStepBack = (step) => {
    switch (step) {
      case 1: this.stepTipoRegistro = "active";
              this.stepRepresentante = "";
              this.stepRegistroDatos = "";
              this.stepClave = "";
              this.stepConfirmar = ""; 
              this.stepTipoRegistroL = "";
              this.stepRepresentanteL = "";
              this.stepRegistroDatosL = "";
              this.stepClaveL = "";
              break;

      case 2: this.stepTipoRegistro = ""; 
              this.stepRepresentante = "active";
              this.stepRegistroDatos = "";
              this.stepClave = "";
              this.stepConfirmar = ""; 
              this.stepRepresentanteL = "";
              this.stepRegistroDatosL = "";
              this.stepClaveL = "";

              //limpiar datos ingresados
              this.datosRegistro.telefono2 = "";
              this.datosRegistro.telefono1 = "";
              this.datosRegistro.correo1 = "";
              this.datosRegistro.correo2 = "";
              this.datosRegistro.clave = "";
              this.datosRegistro.claveSeg = "";
              this.datosRegistro.razonSocial = "";
              this.datosRegistro.nroDocumento = "";
              this.selectedPais = 0;
              this.selectedTipDocPais = 0;
              break;

      case 3: this.stepTipoRegistro = ""; 
              this.stepRepresentante = "";
              this.stepRegistroDatos = "active";
              this.stepClave = "";
              this.stepConfirmar = ""; 
              this.stepRegistroDatosL = "";
              this.stepClaveL = "";

              //limpiar datos
              this.datosRegistro.clave = "";
              this.datosRegistro.claveSeg = "";
              break;

      case 4: this.stepTipoRegistro = "";
              this.stepRepresentante = "";
              this.stepRegistroDatos = ""
              this.stepClave = "active"; 
              this.stepConfirmar = "";
              this.stepClaveL = ""; 
              break;
    }
  }

  validarContraseña = (clave) => {
    let hasNumber = /\d/.test(clave);
    let hasUpper = /[A-Z]/.test(clave);
    let hasLower = /[a-z]/.test(clave);
    let hasSymbol = /[!#$%&'()*+,-./:;<=>?@\^_`{[]|}~.]/.test(clave);//--!#$%&'()*+,-./:;<=>?@[\]^_`{|}~.
    //let hasSymbol = /^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{8,20}$/.test(clave);
    // console.log('Num, Upp, Low', hasNumber, hasUpper, hasLower);
    const valid = hasNumber && hasUpper && hasLower && hasSymbol;
    if (!valid) {
        // return what´s not valid
        return { strong: true };
    }
    return false;
  }


  handleChangeStep = (step) => {
    
    switch (step) {
      case 2: 
              if(this.selectedTipoRegistro == "")
              {
                this.toast.error("Debe de seleccionar una opción");
              }
              else
              {
                let pkTipDoc2 = this.selectTipDocPaso2;
                if(!this.isShowPN){
                  this.listarTipDocPaso2(3);
                }
                else{
                  this.listarTipDocPaso2(2);
                }
                this.selectTipDocPaso2 = pkTipDoc2;
                this.stepTipoRegistro = ""; 
                this.stepRepresentante = "active";
                this.stepRegistroDatos = "";              
                this.stepClave = "";
                this.stepConfirmar = ""; 
                this.stepTipoRegistroL = "active";
              }
              break;

        case 3:
              if(this.selectTipDocPaso2 == 0)
              {
                this.toast.error("Seleccione Tipo de Documento");
              }
              else if(this.datosRegistro.nroDocRepresentante == "")
              {
                this.toast.error("Ingrese Nro. de Documento");
              }
              else if(this.textoNumerico(this.datosRegistro.nroDocRepresentante))
              {
                this.toast.error("El número de documento solo deben números");
              }
              else if(this.datosRegistro.nombresRepresentante == "")
              {
                this.toast.error("Registra Nombre");
              }
              else if(this.datosRegistro.apPatRepresentante == "")
              {
                this.toast.error("Registra Apellido Paterno");
              }
              else if(this.datosRegistro.apMatRepresentante == "")
              {
                this.toast.error("Registra Apellido Materno");
              }
              else
              {
                if(!this.isShowPN){ 
                  this.datosRegistro.nroDocumento = this.datosRegistro.nroDocRepresentante;
                }
                this.stepTipoRegistro = ""; 
                this.stepRepresentante = "";
                this.stepRegistroDatos = "active";
                this.stepClave = "";
                this.stepConfirmar = ""; 
                this.stepRepresentanteL = "active";
              }
              break;
      case 4: 
              if(!this.isShowEX){
                if(this.selectedPais == 0)
                {
                  this.toast.error("Por favor selecciona País");
                  break;
                }
                if(this.selectedTipDocPais == 0)
                {
                  this.toast.error("Por favor selecciona Tipo de Documento");
                  break;
                }
              }

              if(this.datosRegistro.nroDocumento == "")
              {
                if(!this.isShowPJ) {
                  this.toast.error("Por favor ingresa el RUC");
                }
                else if(!this.isShowPN){
                  this.toast.error("Por favor ingresa el DNI");
                }
                else if(!this.isShowEX){
                  this.toast.error("Por favor ingresa Nro. de Documento");
                }
                break;
              }
              else
              {
                let tipo, pais, tipDocPais
                if(!this.isShowPJ){
                  tipo = 1; pais = 104; tipDocPais = 120;
                }
                else if(!this.isShowPN){
                  tipo = 2; pais = 104; tipDocPais = this.selectTipDocPaso2;
                }
                else if(!this.isShowEX){
                  tipo = 3; pais = this.selectedPais; tipDocPais = this.selectedTipDocPais;
                }
                this.usuariosService.validarUsuario(tipo, tipDocPais, pais, this.datosRegistro.nroDocumento).subscribe((response) => {
                  console.log(response)
                  if(response.rptTipo == 0){                  
                    this.toast.error(response.rptMsg);
                  }
                  else{
                    this.datosRegistro.TipoDocumento = response.cTipoDocumento;
                    if(!this.isShowPJ) {                      
                      if(this.datosRegistro.razonSocial == "")
                      {
                        this.toast.error("Por favor verifique el Nro de Documento ingresado"); //preguntar mensaje
                        //this.toast.error("NO está registrado como representante legal  en el RENAT. No es posible continuar.");
                      }
                      else{
                        if(this.datosRegistro.correo1 == "")
                        {
                          this.toast.error("Por favor ingresa mínimo un Email");
                        }
                        else if(!this.esEmailValido(this.datosRegistro.correo1))
                        {
                          this.toast.error("Por favor ingresa un Email válido");
                        }
                        else if(this.datosRegistro.telefono1 == "")
                        {
                          this.toast.error("Por favor ingresa mínimo un número de Celular");
                        }
                        else
                        {
                          if(this.datosRegistro.correo2 != "" && !this.esEmailValido(this.datosRegistro.correo2))
                          {
                            this.toast.error("Por favor ingresa un Email 2 válido");
                          }
                          else
                          {
                            this.datosRegistro.resumenCorreo = this.datosRegistro.correo1;
                            if(this.datosRegistro.correo2 != "")
                            {
                              this.datosRegistro.resumenCorreo = this.datosRegistro.correo1 + "; " + this.datosRegistro.correo2;
                            }
                            this.datosRegistro.resumenTelefono = this.datosRegistro.telefono1;
                            if(this.datosRegistro.telefono2 != "")
                            {
                              this.datosRegistro.resumenTelefono = this.datosRegistro.telefono1 + "; " + this.datosRegistro.telefono2;
                            }
                            this.stepTipoRegistro = "";
                            this.stepRepresentante = ""; 
                            this.stepRegistroDatos = "";
                            this.stepClave = "active"; 
                            this.stepConfirmar = "";
                            this.stepRegistroDatosL = "active";
            
                            this.isShowModalDatos = !this.isShowModalDatos;                      
                          }
                        }
                      }
                    }
                    else if(!this.isShowEX){
                      if(this.datosRegistro.razonSocial == "")
                      {
                        this.toast.error("Por favor ingresa Razón Social");
                      }
                      else{
                        if(this.datosRegistro.correo1 == "")
                        {
                          this.toast.error("Por favor ingresa mínimo un Email");
                        }
                        else if(!this.esEmailValido(this.datosRegistro.correo1))
                        {
                          this.toast.error("Por favor ingresa un Email válido");
                        }
                        else if(this.datosRegistro.telefono1 == "")
                        {
                          this.toast.error("Por favor ingresa mínimo un número de Celular");
                        }
                        else
                        {
                          if(this.datosRegistro.correo2 != "" && !this.esEmailValido(this.datosRegistro.correo2))
                          {
                            this.toast.error("Por favor ingresa un Email 2 válido");
                          }
                          else
                          {
                            this.datosRegistro.resumenCorreo = this.datosRegistro.correo1;
                            if(this.datosRegistro.correo2 != "")
                            {
                              this.datosRegistro.resumenCorreo = this.datosRegistro.correo1 + "; " + this.datosRegistro.correo2;
                            }
                            this.datosRegistro.resumenTelefono = this.datosRegistro.telefono1;
                            if(this.datosRegistro.telefono2 != "")
                            {
                              this.datosRegistro.resumenTelefono = this.datosRegistro.telefono1 + "; " + this.datosRegistro.telefono2;
                            }
                            this.stepTipoRegistro = "";
                            this.stepRepresentante = ""; 
                            this.stepRegistroDatos = "";
                            this.stepClave = "active"; 
                            this.stepConfirmar = "";
                            this.stepRegistroDatosL = "active";
            
                            this.isShowModalDatos = !this.isShowModalDatos;                      
                          }
                        }
                      }
                    }
                    else if(!this.isShowPN){
                      if(this.datosRegistro.correo1 == "")
                        {
                          this.toast.error("Por favor ingresa mínimo un Email");
                        }
                        else if(!this.esEmailValido(this.datosRegistro.correo1))
                        {
                          this.toast.error("Por favor ingresa un Email válido");
                        }
                        else if(this.datosRegistro.telefono1 == "")
                        {
                          this.toast.error("Por favor ingresa mínimo un número de Celular");
                        }
                        else
                        {
                          if(this.datosRegistro.correo2 != "" && !this.esEmailValido(this.datosRegistro.correo2))
                          {
                            this.toast.error("Por favor ingresa un Email 2 válido");
                          }
                          else
                          {
                            this.datosRegistro.resumenCorreo = this.datosRegistro.correo1;
                            if(this.datosRegistro.correo2 != "")
                            {
                              this.datosRegistro.resumenCorreo = this.datosRegistro.correo1 + "; " + this.datosRegistro.correo2;
                            }
                            this.datosRegistro.resumenTelefono = this.datosRegistro.telefono1;
                            if(this.datosRegistro.telefono2 != "")
                            {
                              this.datosRegistro.resumenTelefono = this.datosRegistro.telefono1 + "; " + this.datosRegistro.telefono2;
                            }
                            this.stepTipoRegistro = "";
                            this.stepRepresentante = ""; 
                            this.stepRegistroDatos = "";
                            this.stepClave = "active"; 
                            this.stepConfirmar = "";
                            this.stepRegistroDatosL = "active";
            
                            this.isShowModalDatos = !this.isShowModalDatos;  
                          }
                        }
                    }
                  }
                });
              }
              break;

      case 5: if(this.datosRegistro.clave == "")
              {
                this.toast.error("Por favor ingresa contraseña");
              }
              else if(this.datosRegistro.claveSeg == "")
              {
                this.toast.error("Por favor repita la contraseña");
              }
              else if(this.datosRegistro.clave != this.datosRegistro.claveSeg)
              {
                this.toast.error("Por favor ingresa la misma contraseña");
              }
              else if(this.datosRegistro.clave.length < 8)
              {
                this.toast.error("Por favor la contraseña debe tener mínimo 8 caracteres");
              }
              else if(this.validarContraseña(this.datosRegistro.clave))
              {
                this.toast.error("Contraseña inválida");
              }
              else
              {
                this.stepRegistroDatos = "";
                this.stepRepresentante = "";
                this.stepTipoRegistro = ""; 
                this.stepClave = ""; 
                this.stepConfirmar = "active";
                this.stepClaveL = "active"; 
                //console.log(this.datosRegistro);
              }
              break;
    }
  } 

  finalizar = () => {
    if(!this.chkCPDP)
    {
      this.toast.error("Para poder finalizar debes leer y aceptar la Cláusula de Protección de Datos Personales");
    }
    else if(!this.chkTC)
    {
      this.toast.error("Para poder finalizar debes leer y aceptar los Términos y Condiciones");
    }
    else{
      this.isShowFin = !this.isShowFin;
      this.isShowProceso = ! this.isShowProceso;
      this.registroUsuario();
    }
  }
  downloadPdf = () => {
    /*const pdfUrl = './assets/archivos/TerminosCondiciones.pdf';
    const pdfName = 'TerminosCondiciones';
    FileSaver.open(pdfUrl);*/
  }

  checkTC = () => {
    this.isShowModalTC = !this.isShowModalTC;
    this.isDisabledTC = false;
  }
  
  checkCPDP = () => {
    this.isShowModalTC = !this.isShowModalTC;
    this.isShowModalCPDP = !this.isShowModalCPDP;
    this.isDisabledCPDP = false;
  }
  
  emailRegistro(tipodoc, nrodoc, usuario, codigo, email, titulo, pass){
    this.datosEmail = {
      empresa: usuario,
      tipdoc: tipodoc,
      usuario: nrodoc,
      clave: pass,
      correo: email,
      link: environment.loingUrlPortal,
      codverifica: "",
      asunto: titulo
    }
    
    this.usuariosService.emailRegistro(this.datosEmail).subscribe(
        (data) => {
          //console.log(data) 
        },
      (error) => {
          //console.log(error)
      }
    )
  }
  
}
